/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x569e=['pluginName'];(function(_0x6cb111,_0x569ea9){var _0x32fb75=function(_0x21c92e){while(--_0x21c92e){_0x6cb111['push'](_0x6cb111['shift']());}};_0x32fb75(++_0x569ea9);}(_0x569e,0x80));var _0x32fb=function(_0x6cb111,_0x569ea9){_0x6cb111=_0x6cb111-0x0;var _0x32fb75=_0x569e[_0x6cb111];return _0x32fb75;};import{ContextPlugin as _0x2d8991}from'ckeditor5/src/core';import _0x11c3ab from'./realtimecollaborativeediting/sessions';import _0x30c0f9 from'./presencelist/presencelistui';export default class s extends _0x2d8991{static get['requires'](){return[_0x11c3ab,_0x30c0f9];}static get[_0x32fb('0x0')](){return'PresenceList';}}